module.exports = __webpack_public_path__ + "nc_static/media/close-popup.d61674fd.svg";